import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { Flex } from '@hausgold/designsystem';
import TrustBox from '../../TrustBox.js';
import { jsx } from '@emotion/react';
var Footer = function Footer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Flex, _extends({
    justifyContent: "center",
    backgroundColor: "rgba(217,218,222,.3)",
    py: 3,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: "#ccc",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4
    // prevent content layout shift when loading TrustBox Widget is done
    ,

    minHeight: "120px"
  }, props), jsx(TrustBox, null));
};
export { Footer as default };